import React, { useEffect, useState } from "react";
import QRCode from 'qrcode.react';
import { Typography, TextField, Button, Box } from "@mui/material";
import { axiosPost } from "../../services/axios/apiCalls";

function Card2fa({ systemData, loginUser, loginData, launchErrorModal }) {
    /** QR */
    const [otpAuth, setOtpAuth] = useState('')
    const [hasQr, setHasQr] = useState(true)

    /** CONST */
    const textInputProps = { maxLength: 6 }
    const [pass, setPass] = useState('')

    async function handleSubmit(event) {
        event.preventDefault();

        const url = '/2fa/verify'
        const response = await axiosPost(url, { username: loginData.user, pass, otpAuth })

        if (response.status === 200) {
            await loginUser(loginData.user, pass, loginData.auth_type);
        } else {
            launchErrorModal(response.status, response.message)
        }
    }

    /** Recuperar datos del access code */
    const fetchTotp = async (username) => {
        const url = '/2fa/generate'
        const response = await axiosPost(url, { username })

        if (response.status === 200) {
            setHasQr(false)
            setOtpAuth(response.data)
        } else if (response.status === 409)
            setHasQr(true)
        else
            launchErrorModal(response.status, response.message)
    }

    useEffect(() => {
        if (systemData.pass_2fa_auth) {
            fetchTotp(loginData.user)
        }
    }, [systemData])

    return (
        <>
            <Box className="custom-2fa-card col-lg-4 col-md-6 col-sm-9 col-11 kiwox-panel shadow d-flex flex-column align-items-center">
                <div className="pb-4">
                    <img src={systemData.entry_logo} alt="report-automator" />
                </div>
                {/* ------------------------------ START TEXTO EN LOGIN EDITABLE ------------------------------ */}
                <Typography className="fs-5 mb-3 login-title">{systemData.login_title}</Typography>
                {/* ------------------------------ END TEXTO EN LOGIN EDITABLE ------------------------------ */}
                {/* ------------------------------ START QR ------------------------------ */}
                {!hasQr &&
                    <>
                        <QRCode value={`otpauth://totp/KiwoxSpa?secret=${otpAuth}`} />
                        <Typography className="mt-3">Escanea el codigo de arriba con tu app de doble verificación e ingresa el código abajo</Typography>
                    </>
                }
                {hasQr &&
                    <div>
                        Consulta tu app de doble verificación para ingresar tu código temporal
                    </div>
                }
                {/* ------------------------------ END QR ------------------------------ */}
                <form className="box-form" onSubmit={handleSubmit}>
                    {/** Campo password */}
                    <TextField
                        className="form-password mb-1 mt-1"
                        required
                        id="pass"
                        name="pass"
                        label="Pass"
                        type="password"
                        value={pass}
                        inputProps={textInputProps}
                        onChange={(event) => {
                            const re = /^[0-9\b]+$/;
                            if (event.target.value === '' || re.test(event.target.value))
                                setPass(event.target.value)
                        }}
                        size="small"
                    />
                    {/** Botón login */}
                    <Button className="btn-principal col-7 mt-4" type="submit">
                        Verificar
                    </Button>
                </form>
            </Box>
        </>
    )
}

export default Card2fa;